export default {
    DOM: {
        getDomPath(el) {
            if (!el || !(el instanceof Element)) 
                return;
            var path = [];
            while (!!el && el.nodeType === Node.ELEMENT_NODE) {
                var selector = el.nodeName.toLowerCase();
                if (el.id) {
                    selector += '#' + el.id;
                    path.unshift(selector);
                    break;
                } else {
                    var sib = el, nth = 1;
                    while (sib = sib.previousElementSibling) {
                        if (sib.nodeName.toLowerCase() == selector)
                            nth++;
                    }
                    if (nth != 1)
                        selector += ":nth-of-type("+nth+")";
                }
                path.unshift(selector);
                el = el.parentNode;
            }
            return path.join(" > ");
        },

        getLongestDomPath(el) {
            if (!el || !(el instanceof Element)) 
                return;
            var path = [];
            while (!!el && el.nodeType === Node.ELEMENT_NODE) {
                var selector = el.nodeName.toLowerCase();
                
                var sib = el, nth = 1;
                while (sib = sib.previousElementSibling) {
                    if (sib.nodeName.toLowerCase() == selector)
                        nth++;
                }
                if (nth != 1)
                    selector += ":nth-of-type("+nth+")";
                
                path.unshift(selector);
                el = el.parentNode;
            }
            return path.join(" > ");
        }
    }
}